import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { VueFire, VueFireAuth } from 'vuefire'
import { firebaseApp } from './firebase'

const app = createApp(App, {
  compilerOptions: {
    isCustomElement: () => false,
    whitespace: 'condense',
    delimiters: ['{{', '}}'],
    comments: false
  }
})

app.config.unwrapInjectedRef = true
app.config.warnHandler = () => null

app.use(VueFire, {
  firebaseApp,
  modules: [VueFireAuth()]
})

app.use(router)
app.mount('#app')
